import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
	researchers: [],
	activities: [],
	user: null,
	numUsers: Number.POSITIVE_INFINITY,
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
